<script setup lang="ts">
export type GwIconVariants =
  | 'grey_transparent_auto' //
  | 'primary-v2_bgLight'
  | 'white_bgLight'
  | 'white_bgLight'
  | 'icon_btn_close'

export interface GwIconProps {
  icon: string // mdi icon name
  variant: GwIconVariants
}
defineProps<GwIconProps>()
</script>

<template>
  <i
    class="gwicon mdi"
    :class="[icon, variant]"
  />
</template>

<style scoped lang="scss">
.gwicon {
  --gwicon-size: 2.25rem;
  --gwicon-width: var(--gwicon-size);
  --gwicon-height: var(--gwicon-size);

  --gwicon-font-size: 1.5rem;
  --gwicon-clr: transparent;
  --gwicon-bg: transparent;

  width: var(--gwicon-width);
  height: var(--gwicon-height);
  font-size: var(--gwicon-font-size);
  color: var(--gwicon-clr);
  background-color: var(--gwicon-bg);
  border-radius: var(--app-rad-3);
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.primary-v2_bgLight {
  --gwicon-clr: var(--app-clr-primary-v2);
  --gwicon-bg: var(--app-light-3);
}
.white_bgLight {
  --gwicon-clr: white;
  --gwicon-bg: var(--app-light-3);
}

.grey_transparent_auto {
  --gwicon-clr: var(--app-clr-grey-2);
  --gwicon-bg: transparent;
  --gwicon-width: auto;
}
</style>
